import { render, staticRenderFns } from "./dynamicList.vue?vue&type=template&id=6b7fd3a3"
import script from "./dynamicList.vue?vue&type=script&lang=js"
export * from "./dynamicList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports